export default __webpack_public_path__ + "static/media/zara-app.d2042803.png";